/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import { IconProps } from "../types";
const ArrowUpRightIcon = ({
  size = 24,
  ...props
}: IconProps) => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width={size} height={size} {...props}><path fillRule="evenodd" d="M7.25 4.5a1 1 0 0 1 1-1H19.5a1 1 0 0 1 1 1v11.25a1 1 0 1 1-2 0V6.914L5.207 20.207a1 1 0 0 1-1.414-1.414L17.086 5.5H8.25a1 1 0 0 1-1-1" clipRule="evenodd" /></svg>;
};
export default ArrowUpRightIcon;